import { render } from "./AppManage.vue?vue&type=template&id=045a3606"
import script from "./AppManage.vue?vue&type=script&lang=js"
export * from "./AppManage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\geneuin\\developer\\hwian\\hwian-install-mobile-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__